import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MessagingService } from './notifications/messaging';
import { PostService,UrlAttachmentService,ImageService,AuthGuard } from './firebase/firebase.service';
import { MetadataService } from './url/metadata.service';
import {PushNotificationsService} from './notifications/push.notification.service';
import {SeoService} from './seo/seo.service';


@NgModule({
  imports: [
    CommonModule
  ],
  declarations: []
})
export class ServicesModule { 


	static forRoot(){
		return {
			ngModule:ServicesModule,
			providers:[
				MessagingService,
				PostService,
				UrlAttachmentService,
				ImageService,
				AuthGuard,
				MetadataService,
				PushNotificationsService,
				SeoService
			]
		}
	}

}